module.exports = __webpack_public_path__ + "static/media/zoom-out.62653a03.svg";